import SignInOptionsLink from './SignInOptionsLink';
import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { authService } from '../services/authService';

const AnonymousUserButton: React.FC = () => {
  const { loginWithGoogle } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="anonymous-user" ref={dropdownRef}>
      <button
        className="anonymous-user-button"
        onClick={() => setShowDropdown(!showDropdown)}
        type="button"
        title="Click for login options"
      >
        <div className="anonymous-user-avatar">
          <span className="anonymous-user-icon">👤</span>
        </div>
      </button>

      {showDropdown && (
        <div className="anonymous-user-dropdown">
          <div className="anonymous-user-dropdown-header">
            <div className="anonymous-user-info">
              <div className="anonymous-user-avatar-large">
                <span className="anonymous-user-icon-large">👤</span>
              </div>
              <div className="anonymous-user-details">
                <div className="anonymous-user-label">Guest User</div>
                <div className="anonymous-user-subtitle">Not signed in</div>
              </div>
            </div>
          </div>
          <div className="anonymous-user-dropdown-divider"></div>
          <div className="anonymous-user-dropdown-actions">
            <button
              className="login-button-dropdown login-button-google"
              onClick={() => {
                loginWithGoogle();
                setShowDropdown(false);
              }}
              type="button"
              aria-label="Sign in with Google"
              data-testid="dropdown-google-login-btn"
            >
              <svg className="login-icon-svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              <span aria-hidden="true">Sign in with Google</span>
            </button>
            <button
              className="login-button-dropdown login-button-facebook"
              onClick={() => {
                authService.loginWithFacebook();
                setShowDropdown(false);
              }}
              type="button"
              aria-label="Sign in with Facebook"
              data-testid="dropdown-facebook-login-btn"
            >
              <svg className="login-icon-svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              <span aria-hidden="true">Sign in with Facebook</span>
            </button>
            <SignInOptionsLink />
          </div>
        </div>
      )}
    </div>
  );
};

export default AnonymousUserButton;
